export const blockIconsTravelPoolNew = (
	<span className='material-symbols-outlined'>pool</span>
);
